import type { ReactNode } from "react";
import { Suspense } from "react";

import { isEditing } from "@builder.io/sdk-react";

import { Section as UISection } from "@jti/core-components/components/Section";

import { getBuilderChildrenCount } from "@/libs/builder/utils/getBuilderChildrenCount";

import { Placeholder } from "../Placeholder/Placeholder";

type SectionProps = {
  children: ReactNode;
  enableSuspense?: boolean;
};

export function Section({ children, enableSuspense = false }: SectionProps) {
  if (isEditing() && getBuilderChildrenCount(children) === 0) {
    return <Placeholder>Drag and drop component here</Placeholder>;
  }

  return <UISection>{enableSuspense ? <Suspense>{children}</Suspense> : children}</UISection>;
}
